<template>
    <v-app id="app">

        <v-layout row>

            <v-flex lg12 class="mt-10 px-3">

                <div class="font-weight-black"> <span> {{tutorName}} </span>  </div>

           
                <v-row justify-lg="end" justify-sm="start" class="ml-lg-12 ml-1 mt-lg-0 mt-2">

                    <v-col cols="1" lg="6" xs="12">

                        <v-row style="width:300px !important;">
                             <v-col lg="10" xs="12">   <v-autocomplete
                                v-model="month"
                                :items="months"
                                item-text="month"
                                item-value="no"
                                dense
                                class="ml-lg-0"
                                prepend-icon="mdi-calendar"
                                label="SELECT MONTH"
                                @change="getComplaints()"
                            
                            ></v-autocomplete>  </v-col>

                        </v-row>

                    </v-col>

                </v-row>
                
                
               <v-data-table :sort-by.sync="sortBy" :sort-desc.sync="sortDesc" dense :headers="headers" hide-default-footer :items="tables" item-key="name" class="elevation-0 table-rating">
                 
                             <template slot="item" slot-scope="props">

                                        <tr @click="sendDataForm(props.item)">
                                            <td class="text-left"> {{props.item.cd}} </td>
                                            <td class="text-left"> {{props.item.ct}} </td>
                                            <td class="text-left"> {{props.item.ts}} </td>
                                            

                                        </tr>

                                    </template>


                </v-data-table> 

                <div class="px-lg-4">

                    <v-btn depressed color="add-new" @click="addnew()"> ADD NEW </v-btn>

                </div>

            </v-flex>
        
        </v-layout>


    </v-app>
</template>
<script>
import Vue from 'vue'
import axios from 'axios'
Vue.use(axios)
export default {
    name:'complaintsForm',
    props:['UpRecord','cdataU'],
    data: () => ({
        month:'',
        months: [{'no':'0','month':'January'}, {'no':'1','month':'February'}, {'no':'2','month':'March'}, {'no':'3','month':'April'}, {'no':'4','month':'May'}, {'no':'5','month':'June'}, {'no':'6','month':'July'}, {'no':'7','month':'August'}, {'no':'8','month':'September'}, {'no':'9','month':'October'}, {'no':'10','month':'November'}, {'no':'11','month':'December'},],
        tables:[],
        getTutor:[],
        itemPerPage:0,
        tutorName:'',
    }),
    computed: {
       headers(){ return  [{

          
          text: 'Class Date',
          align: 'left',
          sortable: false,
          value: 'cd',
          class: "grey lighten-2"
        },
        { text: 'Class Time',align: 'left', value: 'ct' , class: "grey lighten-2", sortable: false,},
        { text: 'Timestamp',align: 'left', value: 'ts' , class: "grey lighten-2", sortable: false,},
        
        ]}
    },
    mounted(){

        axios.get('https://phone.megatalking.com/origin/api/monitoring.php?action=getTutors')
        //.then(response=>console.warn(response.data))
        .then(response=>{
        
          let tutorlist = response.data
        

              for(let i = 0 ; i<=tutorlist.length ; i++){
                    


                    if(this.$route.params.t_id.toString().toLowerCase().indexOf(tutorlist[i].tutor_id.toLowerCase()) !== -1){
                        this.tutorName = tutorlist[i].tutor_full_name
                    }

               }
               
              })

              this.UpRecord.$on('UpdatedComplaintsData', this.UpdatedComplaintsData)
              
    },
    methods:{
       

        getComplaints(){

                this.tables = []
                 axios.get('http://localhost/megatalking/performance/tutorperf.php?actionTaken=getcomplaints')
                .then(response=>{


                    let data  = response.data

                    
                    for(let x = 0 ;  x < data.length ; x++){

                        let date = new Date(data[x].timestamp)
                        
                        if(date.getMonth()==this.month){
                            
                            this.tables.push({
                                
                                cd: data[x].class_date,
                                ct:data[x].class_time,
                                ts:date.getFullYear()+"-"+(date.getMonth() >= 9 ? (date.getMonth()+1) : "0"+(date.getMonth()+1))+"-"+(date.getDate() > 9 ? date.getDate() : "0"+date.getDate())+" "+(date.getHours() > 9 ? date.getHours() : "0"+date.getHours())+":"+(date.getMinutes() > 9 ? date.getMinutes() : "0"+date.getMinutes())+":"+(date.getSeconds() > 9 ? date.getSeconds() : "0"+date.getSeconds()),
                                updateId:(x+1),
                                tyCom:[{

                                        list:data[x].tyCom[0].list,
                                        other: data[x].tyCom[0].other


                                }],
                                tutorId:data[x].tutorId,
                                actTaken:[{
                                        list: data[x].actTaken[0].list,
                                        other:data[x].actTaken[0].other
                                }],
                                stud_name:data[x].stud_name,
                                timestamp:data[x].timestamp,
                                class_date:data[x].class_date,
                                class_time:data[x].class_time,
                                complaints:data[x].complaints


                            })


                        } 

                    }

                }).catch(error=>console.log('this is the error '+error))

        },

        sendDataForm(data){

            this.$emit('complaintsForm',data)

        },

        UpdatedComplaintsData(){

            let data = Vue.prototype.$updatedComplaints
            let objIndex = this.tables.findIndex((obj => obj.updateId == data.updateId));

           this.tables[objIndex].cd = data.class_date
           this.tables[objIndex].ct = data.class_time
           this.tables[objIndex].tyCom[0].list = data.tyCom[0].list
           this.tables[objIndex].tyCom[0].other = data.tyCom[0].other
           this.tables[objIndex].actTaken[0].list = data.actTaken[0].list
           this.tables[objIndex].actTaken[0].other = data.actTaken[0].other
           this.tables[objIndex].stud_name = data.stud_name
           this.tables[objIndex].complaints = data.complaints
           

        },

        addnew(){
             let val = true
            this.$emit('addNewTrigger',val)
        }



 }
}
</script>
<style scoped>
.add-new{
    background-color: rgb(0, 157, 250) !important;
    color:white;
    font-weight: bold;
    font-size:10px;
}

</style>